import getMainLocale from './get-main-locale';
import getCurrentLocale from './get-current-locale';
import getSiteLocales from './get-site-locales';
import getSupportedLocales from './get-supported-locales';

export default {
  getSiteLocales,
  getCurrentLocale,
  getMainLocale,
  getSupportedLocales,
};
